import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function ReturnedItem (props){

    return <BasicCrudScreenType id ="ReturnedItem" table ="ReturnedItem" view ="VwReturnedItem" exportFormatItem={() => {}}/>
}

export default ReturnedItem;